<template>
  <div class="stickysidebar">
    <div class="card user-sidebar mb-4 mb-lg-0 mb-4 mb-lg-0 p-4">
      <div class="card-header user-sidebar-header mb-4">
        <div class="d-flex justify-content-center align-items-center flex-column">
          <span class="user rounded-circle avatar avatar-xxl mb-2">
            <img
              src="@/assets/img/profiles/avatar-21.jpg"
              class="img-fluid rounded-circle"
              alt="Img"
            />
          </span>
          <h6 class="mb-2">John Smith</h6>
          <p class="fs-14">Member Since Sep 2021</p>
        </div>
      </div>
      <div class="card-body user-sidebar-body pt-0">
        <ul>
          <li class="mb-4">
            <router-link to="/customer/user-dashboard" class="d-flex align-items-center">
              <i class="ti ti-layout-grid me-2"></i>
              Dashboard
            </router-link>
          </li>
          <li class="mb-4">
            <router-link to="/customer/user-booking-list" class="d-flex align-items-center">
              <i class="ti ti-device-mobile me-2"></i>
              Bookings
            </router-link>
          </li>
          <li class="mb-4">
            <router-link to="/customer/favourites" class="d-flex align-items-center">
              <i class="ti ti-heart me-2"></i>
              Favorites
            </router-link>
          </li>
          <li class="mb-4">
            <router-link to="/customer/customer-wallet" class="d-flex align-items-center">
              <i class="ti ti-wallet me-2"></i>
              Wallet
            </router-link>
          </li>
          <li class="mb-4">
            <router-link to="/customer/customer-reviews" class="d-flex align-items-center">
              <i class="ti ti-star me-2"></i>
              Reviews
            </router-link>
          </li>
          <li class="mb-4">
            <router-link to="/customer/user-chat" class="d-flex align-items-center">
              <i class="ti ti-message-circle me-2"></i>
              Chat
            </router-link>
          </li>
          <li class="submenu mb-4">
            <a href="javascript:void(0);" class="d-block mb-3" 
              :class="{ 'active subdrop': 
                isActive('/customer-settings/account-settings') || 
                isActive('/customer-settings/security-settings') || 
                isActive('/customer-settings/notification-settings') || 
                isActive('/customer-settings/connected-apps')               
              }" @click="toggleSubmenu">
              <i class="ti ti-settings me-2"></i>
              <span>Settings</span>
              <span class="menu-arrow"></span>
            </a>
            <ul :style="{ display: isSubmenuOpen ? 'block' : 'none' }" class="ms-4">
              <li class="mb-3" :class="{ active: isActive('/customer-settings/account-settings') }">
                <router-link
                  to="/customer-settings/account-settings"
                  class="fs-14 d-inline-flex align-items-center"
                >
                  <i class="ti ti-chevrons-right me-2"></i>Account Settings
                </router-link>
              </li>
              <li class="mb-3" :class="{ active: isActive('/customer-settings/security-settings') }">
                <router-link
                  to="/customer-settings/security-settings"
                  class="fs-14 d-inline-flex align-items-center"
                >
                  <i class="ti ti-chevrons-right me-2"></i>Security Settings
                </router-link>
              </li>
              <li class="mb-3" :class="{ active: isActive('/customer-settings/notification-settings') }">
                <router-link
                  to="/customer-settings/notification-settings"
                  class="fs-14 d-inline-flex align-items-center"
                >
                  <i class="ti ti-chevrons-right me-2"></i>Notifications
                </router-link>
              </li>
              <li class="mb-3" :class="{ active: isActive('/customer-settings/connected-apps') }">
                <router-link
                  to="/customer-settings/connected-apps"
                  class="fs-14 d-inline-flex align-items-center"
                >
                  <i class="ti ti-chevrons-right me-2"></i>Connected Apps
                </router-link>
              </li>
              <li class="mb-3">
                <a
                  href="javascript:void(0);"
                  data-bs-toggle="modal"
                  data-bs-target="#del-account"
                  class="fs-14"
                >
                  <i class="ti ti-chevrons-right me-2"></i>Delete Account
                </a>
              </li>
            </ul>
          </li>
          <li class="mb-0">
            <router-link to="/" class="d-flex align-items-center">
              <i class="ti ti-logout me-2"></i>
              Logout
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  setup() {
    const route = useRoute();
    const isSubmenuOpen = ref(false);

    const isActive = (path) => {
      return route.path === `/${path}` || route.path.startsWith(`/${path}/`);
    };

    const toggleSubmenu = () => {
      isSubmenuOpen.value = !isSubmenuOpen.value;
    };

    // Automatically open submenu if any settings path is active
    watch(
      () => route.path,
      (newPath) => {
        isSubmenuOpen.value = [
          "/customer-settings/account-settings",
          "/customer-settings/security-settings",
          "/customer-settings/notification-settings",
          "/customer-settings/connected-apps",
        ].some((subPath) => newPath.startsWith(subPath));
      },
      { immediate: true }
    );

    return { isActive, isSubmenuOpen, toggleSubmenu };
  },
});
</script>
